var dealers;
$(document).ready(function(){
	var allVariants=[];
	var allPieces=[];
	if(typeof allVariantIds != 'undefined'){
         getBuyNowData();
    }
	
	function getBuyNowData () {
       channelSightURL =   window.environment.channelSightURL +'?source=MultipleSku&orderby=Name_Fixed&format=json'+ '&brand='+ window.environment.brand+ '&skulist=' + allVariantIds + '&countryCode=' +window.environment.countryCode ;
        $.ajax({
            type: "GET",
            url: channelSightURL,
			dataType : "json",

			success: function (data) {
				  if(data.Status==="OK"  &&  typeof data.dealers != 'undefined' && data.dealers.length>0)	      
	              {
				       $('#buynowlink').show(1000);
					   dealers=data.dealers;
				  }
			},
            error: function (error) {
		}
    });
}
	$('#buynowlink').click(function(event){
	        event.preventDefault();
			if($('#ddlBuyNowSizes').length===0){
				bindDealerData();
			}
			else
			{
				showMessage(window.labels.selectSizeForRetailer);
	        }	
			
	});
	
	$('#ddlBuyNowSizes').change(function(){
		var selectedOption=$(this).val();
		if(selectedOption==="0")
		{
			showMessage(window.labels.selectSizeForRetailer);
				$('div#dealersConatiner').html('');
		}
		else
		{
			bindDealerData(selectedOption);
		}
	});
	
	function showMessage(message)
	{
		        var $messageContainer= $('div.messageInfo-wrap');
				 if($messageContainer.length>0)
				 {
				      $messageContainer.removeClass('hide');
				      var $messageField=$messageContainer.find('p.messageInfo');
				      $messageField.text(message);
                 }		
	}
	
	function bindDealerData(selectedSKUs){
		        allVariants=allVariantIds.split(',');
				allPieces=allPieceCounts.split(',');
				var passedSKUs=[]
				if(selectedSKUs !== undefined )
				{
				        passedSKUs = selectedSKUs.split(',');           
				}
				
				var $html=$('<div></div>').html('');
				var $packInfoHTML=$('<div></div>').html('');
		 	      $(dealers).each(function(index,itemdata){
				    $packInfoHTML.html('');
					$(itemdata.products).each( function(productIndex,productItemData){
						var buyNowCaption=window.labels.outOfStock;
						
						var $buyNowButtonHTML=$('<span class="u-btnBuy status-outofStock btn"></span>').text(buyNowCaption);
						if( passedSKUs.length===0 ||  ($.inArray(productItemData.sku,passedSKUs) > -1) ){
							var pieceInfo='';
							var currentSKUIndex=$.inArray(productItemData.sku,allVariants );
							if(currentSKUIndex>-1)
							{
							    	pieceInfo=allPieces[currentSKUIndex] + window.labels.piecesLabel;
							}
							
                            if(productItemData.availability==="YES")
							{
								buyNowCaption=window.labels.buyNow;
								$buyNowButtonHTML=$('<a target="_blank" class="u-btnBuy statusAvailable btn' + ' "></a>').text(buyNowCaption);
								$buyNowButtonHTML.attr('href',productItemData["buy-url"]);
							}	
							var imageClass='';
							if($packInfoHTML.html()!=='')
							{
								$packInfoHTML.html($packInfoHTML.html().replace('showBorder','hideBorder'));  
								imageClass='show-sm hide';
						    }
							var $img=$('<img class="productVendor-img'+ imageClass + '">');
							$img.attr('src',itemdata['logo-url']);
							$img.attr('alt',itemdata['name']);

							var $packInfoRowContainerHTML=$('<div class="row productInfo-Details showBorder"></div>'); 
							$packInfoRowContainerHTML.append($('<div class="productVendor-wrap col-7 col-md-7 col-xs-6"> </div>').prepend($img));
							$packInfoRowContainerHTML.append($('<div class="productCount-wrap col-2 col-md-2 col-xs-6 "></div>').text(pieceInfo));
							$packInfoRowContainerHTML.append($('<div class="productStatus-wrap col-3 col-md-3 col-xs-12 "></div>').append($buyNowButtonHTML));	
							
							$packInfoHTML.append($packInfoRowContainerHTML);
							
							
							
                       }
						
					});
					
					if($packInfoHTML.html() !== '')
					{
						$html.append($packInfoHTML.html());
					}
					
				}); 
				if($html.html() !== '')
				{
					$html.prepend($('<div class="row"><div class="col-7 col-md-7 col-xs-6"></div><div class="col-2 col-md-2 col-xs-6 u-rowTitle">'+ window.labels.packCount+'</div><div class="col-3"></div></div>'));
					$('div#dealersConatiner').html($html.html());
					 var $messageContainer= $('div.messageInfo-wrap');
				 if($messageContainer.length>0)
				 {
				      $messageContainer.addClass('hide');
				 }		
				}
				else
				{
					$('div#dealersConatiner').html('');
					showMessage(window.labels.noProductForRetailer);
				}
		  }
	});



